<script setup>
import { ref } from 'vue'
import { CashIcon } from "@heroicons/vue/outline"
import { usePaymentsStore } from '@/Stores/payments'
const payments = usePaymentsStore();

const props = defineProps({
	invoice: {
		type: Object,
		required: true,
	},
	cardable_type: {
		type: String,
		required: true,
	},
	cardable_id: {
		required: true,
	},
})

function showCardForm(){
	payments.showCardForm(props.invoice, props.cardable_type, props.cardable_id)
}

</script>

<template>
	<Button
		@click.stop.prevent="showCardForm" 
		class="w-24"
		variant="outline"
		color="blue"
		size="sm"
		data-testid="pay-invoice-btn"
	>
		<CashIcon class="w-4 mr-2" /> Pay
	</Button>
</template>